module.exports = __webpack_public_path__ + "static/media/pdiLogo.5e26166a.png";